/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_SERVICEDESK_ISSUE_TYPES = 'SERVICEDESK_ISSUE_TYPES';
